














































































































































































































































    import AbpBase from "../../../lib/abpbase";
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
    import Util from '../../../lib/util'
    import {GetRecipeData,Prescribe,DialysOn,GetBeforeDialysOn} from '../../../api/dialysisProcess'

    import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'

    import dialysisBeginForm from './dialysisBeginForm'


    @Component({
        components:{
            uploadImg
        }
    })
    export default class  extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:{}}) data:any;

        form:dialysisBeginForm = new dialysisBeginForm()


        //透析上下机类型
        dialysisType = 1
        piclist:any = {}

        //表单值
        rules = {};
        picConfirm(list:any){
            let paths = list.map((item:any)=>{
                return item.path
            })
            this.form.vaAssest.imagePath = paths.join(',')
        }
        //上机
        async save(){
            this.form.recipeId = this.data.recipeId
            let data = this.form
            let res = await DialysOn(data)
            if(res.status==1){
                this.$emit('input',false);
                this.$emit('on-back')
            }
        }

        async created() {
            console.log(this.form)
            await this.getBeforeDialysOn()
        }
        diyInfo:any = { //初始化是定义好 vascularAccess和weight  不会报错
	        vascularAccess:{},
	        weight:{}
        }
        //加载
        async getBeforeDialysOn(){
            let data = {
                DialysisSignId:this.data.dialysisSignId,
            }
            let res = await GetBeforeDialysOn(data)
            this.diyInfo = res.objects
            console.log(this.diyInfo)
        }


        cancel(){
            // (this.$refs.roleForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisBegin.vue